import {
  DesignMap,
  DesignModuleNode,
  NodeType
} from '../../../types';
import { fixMissingObjects } from './fix-missing-objects';
import { DiagnoseCheckFunction } from './types';

// These node types can be without a parent object.
const ignoredNodeTypes = new Set([
  NodeType.begin,
  NodeType.exit,
  NodeType.note
]);

export const getMissingObjects: DiagnoseCheckFunction = (serialized) => {
  const map = new DesignMap(serialized);
  const { modules } = serialized.components;
  const isMissingObject = (node: DesignModuleNode) => {
    if (node._class === NodeType.module) {
      return !map.modules.get(node.props.parentComponentID!);
    }

    return (
      !ignoredNodeTypes.has(node._class)
      && !map.objects.get(node.props.parentComponentID!)
    );
  };

  const orphanNodes = modules.flatMap((appModule) => {
    const { nodes } = appModule.versions[1].flow;
    return nodes.filter((node) => {
      return isMissingObject(node);
    });
  });

  return {
    fixer: () => {
      return fixMissingObjects(orphanNodes);
    },
    message: `There are ${orphanNodes.length} nodes without a corresponding object.`,
    ok: orphanNodes.length === 0
  };
};
